"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _artifact = _interopRequireDefault(require("./artifact"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ResearchTomogram = /*#__PURE__*/function (_artifact$default) {
  _inherits(ResearchTomogram, _artifact$default);

  var _super = _createSuper(ResearchTomogram);

  function ResearchTomogram(artifact) {
    _classCallCheck(this, ResearchTomogram);

    // eslint-disable-line
    return _super.call(this, artifact);
  }
  /**
   * Returns the Artifact Type (to be used before class initialization)
   * @static
   * @returns {string}
   */


  _createClass(ResearchTomogram, [{
    key: "getNCBITaxID",

    /**
     * Get NCBITaxID
     */
    value: function getNCBITaxID() {
      return this.artifact.details.NCBITaxID;
    }
    /**
     * Set NCBITaxID
     * @param id - NCBITaxID
     */

  }, {
    key: "setNCBITaxID",
    value: function setNCBITaxID(id) {
      this.artifact.details.NCBITaxID = id;
    }
    /**
     * Get Art Notes
     */

  }, {
    key: "getArtNotes",
    value: function getArtNotes() {
      return this.artifact.details.artNotes;
    }
    /**
     * Set Art Notes
     * @param artNotes
     */

  }, {
    key: "setArtNotes",
    value: function setArtNotes(artNotes) {
      this.artifact.details.artNotes = artNotes;
    }
    /**
     * Get Date
     */

  }, {
    key: "getData",
    value: function getData() {
      return this.artifact.details.date;
    }
    /**
     * Set Date
     * @param date
     */

  }, {
    key: "setDate",
    value: function setDate(date) {
      this.artifact.details.date = date;
    }
    /**
     * Get defocus
     */

  }, {
    key: "getDefocus",
    value: function getDefocus() {
      return this.artifact.details.defocus;
    }
    /**
     * Set defocus
     * @param defocus
     */

  }, {
    key: "setDefocus",
    value: function setDefocus(defocus) {
      this.artifact.details.defocus = defocus;
    }
    /**
     * Get Dosage
     */

  }, {
    key: "getDosage",
    value: function getDosage() {
      return this.artifact.details.dosage;
    }
    /**
     * Set Dosage
     * @param dosage
     */

  }, {
    key: "setDosage",
    value: function setDosage(dosage) {
      this.artifact.details.dosage = dosage;
    }
    /**
     * Get Institution
     */

  }, {
    key: "getInstitution",
    value: function getInstitution() {
      return this.artifact.details.institution;
    }
    /**
     * Set Institution
     * @param institution
     */

  }, {
    key: "setInstitution",
    value: function setInstitution(institution) {
      this.artifact.details.institution = institution;
    }
    /**
     * Get Lab
     */

  }, {
    key: "getLab",
    value: function getLab() {
      return this.artifact.details.lab;
    }
    /**
     * Set Lab
     * @param lab
     */

  }, {
    key: "setLab",
    value: function setLab(lab) {
      this.artifact.details.lab = lab;
    }
    /**
     * Get Magnification
     */

  }, {
    key: "getMagnification",
    value: function getMagnification() {
      return this.artifact.details.magnification;
    }
    /**
     * Set Magnification
     * @param magnification
     */

  }, {
    key: "setMagnification",
    value: function setMagnification(magnification) {
      this.artifact.details.magnification = magnification;
    }
    /**
     * Get Microscopist
     */

  }, {
    key: "getMicroscopist",
    value: function getMicroscopist() {
      return this.artifact.details.microscopist;
    }
    /**
     * Set Microscopist
     * @param microscopist
     */

  }, {
    key: "setMicroscopist",
    value: function setMicroscopist(microscopist) {
      this.artifact.details.microscopist = microscopist;
    }
    /**
     * Get Scope Name
     */

  }, {
    key: "getScopeName",
    value: function getScopeName() {
      return this.artifact.details.scopeName;
    }
    /**
     * Set Scope Name
     * @param scopeName
     */

  }, {
    key: "setScopeName",
    value: function setScopeName(scopeName) {
      this.artifact.details.scopeName = scopeName;
    }
    /**
     * Get SID
     */

  }, {
    key: "getSID",
    value: function getSID() {
      return this.artifact.details.sid;
    }
    /**
     * Set SID
     * @param sid
     */

  }, {
    key: "setSID",
    value: function setSID(sid) {
      this.artifact.details.sid = sid;
    }
    /**
     * Get Species Name
     */

  }, {
    key: "getSpeciesName",
    value: function getSpeciesName() {
      return this.artifact.details.speciesName;
    }
    /**
     * Set Species Name
     * @param speciesName
     */

  }, {
    key: "setSpeciesName",
    value: function setSpeciesName(speciesName) {
      this.artifact.details.speciesName = speciesName;
    }
    /**
     * Get Strain
     */

  }, {
    key: "getStrain",
    value: function getStrain() {
      return this.artifact.details.strain;
    }
    /**
     * Set Strain
     * @param strain
     */

  }, {
    key: "setStrain",
    value: function setStrain(strain) {
      this.artifact.details.strain = strain;
    }
    /**
     * Get Tilt Constant
     */

  }, {
    key: "getTiltConstant",
    value: function getTiltConstant() {
      return this.artifact.details.tiltConstant;
    }
    /**
     * Set Tilt Constant
     * @param tiltConstant
     */

  }, {
    key: "setTiltConstant",
    value: function setTiltConstant(tiltConstant) {
      this.artifact.details.tiltConstant = tiltConstant;
    }
    /**
     * Get Tilt Max
     */

  }, {
    key: "getTiltMax",
    value: function getTiltMax() {
      return this.artifact.details.tiltMax;
    }
    /**
     * Set Tilt Max
     * @param tiltMax
     */

  }, {
    key: "setTiltMax",
    value: function setTiltMax(tiltMax) {
      this.artifact.details.tiltMax = tiltMax;
    }
    /**
     * Get Tilt Single-Dual
     */

  }, {
    key: "getTiltSingleDual",
    value: function getTiltSingleDual() {
      return this.artifact.details.tiltSingleDual;
    }
    /**
     * Set Tilt Single-Dual
     * @param tiltSingleDual
     */

  }, {
    key: "setTiltSingleDual",
    value: function setTiltSingleDual(tiltSingleDual) {
      this.artifact.details.tiltSingleDual = tiltSingleDual;
    }
    /**
     * Get Tilt Step
     */

  }, {
    key: "getTiltStep",
    value: function getTiltStep() {
      return this.artifact.details.tiltStep;
    }
    /**
     * Set Tilt Step
     * @param tiltStep
     */

  }, {
    key: "setTiltStep",
    value: function setTiltStep(tiltStep) {
      this.artifact.details.tiltStep = tiltStep;
    }
  }], [{
    key: "getArtifactType",
    value: function getArtifactType() {
      return 'research';
    }
    /**
     * Return the Artifact Subtype (to be used before class initialization)
     * @returns {string}
     */

  }, {
    key: "getArtifactSubtype",
    value: function getArtifactSubtype() {
      return 'tomogram';
    }
  }]);

  return ResearchTomogram;
}(_artifact.default);

var _default = ResearchTomogram;
exports.default = _default;